import type { IModuleDefinition, IRecordTypeDefinition } from '@platform/core/types';
import { isDesigned, isHiddenType } from '@platform/engine/menu/moduleSections';

/**
 * Реалізовані таблиці огляду в порядку прототипу v4 (moTables = [host, ...kids], kids — у порядку ws.modules простору): головна, далі
 * інші реалізовані таблиці за порядком типу в каталозі простору (`order` — позиція в ws.modules; без порядку — за визначенням, після
 * впорядкованих); спроєктовані й приховані — ні. Чиста функція.
 */
export function overviewTablesOf(module: IModuleDefinition, orderOf: (rtKey: string) => number | null | undefined): IRecordTypeDefinition[] {
  const built = module.recordTypes.filter((rt) => !isDesigned(rt) && !isHiddenType(rt));
  const main = built.find((rt) => rt.main || rt.kind === 'main');
  const rank = (rt: IRecordTypeDefinition, i: number) => orderOf(rt.key) ?? Number.MAX_SAFE_INTEGER / 2 + i;
  const rest = built.filter((rt) => rt !== main).map((rt, i) => ({ rt, r: rank(rt, i) })).sort((a, b) => a.r - b.r).map((x) => x.rt);
  return main ? [main, ...rest] : rest;
}
